/// <reference path="api.d.ts" />

namespace API.Client {
    'use strict';

    export interface AgencyReponse {

        "agencyId"?: number;

        "agencyCode"?: number;

        "companyName"?: string;

        "tradingName"?: string;

        "cnpjType"?: string;

        "cnpj"?: number;

        "cnpjDigit"?: number;

        "cnpjBranch"?: number;
    }

}
